import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
// import decryptUserCookie from './utils/decryptUserCookie';

const BusinessCategoryModal = ({ isOpen, setIsOpen, selectedCategory, setSelectedCategory, onSave, categories, setCategories,fetchCategories }) => {
    const [categoryName, setCategoryName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [icon, setIcon] = useState("")
    const urlmain = API_BASE_URL
    const [images, setImages] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    // const userDetails = decryptUserCookie();
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""

    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.name);
            setStatus({ value: selectedCategory.status, label: selectedCategory.status });
        } else {
            setCategoryName('');
            setPosition('');
            setIcon('');
            setStatus(null);
        }
    }, [selectedCategory]);





    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const handleSubmit = async (e) => {
        e.preventDefault();

        const categoryData = {
            name: categoryName,
            status: status?.value,
            main_id: userDetails.main_id,
        };

        const isEdit = !!selectedCategory?.id;
        const url = isEdit
            ? `${urlmain}/business-category/update/${selectedCategory.id}`
            : `${urlmain}/business-category/add/admin1997`;
        const method = isEdit ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(categoryData),
            });

            const res = await response.json();
            if (response.ok) {
                setCategories(prev =>
                    isEdit
                        ? prev.map(cat => cat.id === selectedCategory.id ? { ...categoryData, id: selectedCategory.id } : cat)
                        : [...prev, { ...categoryData, id: res.id }]
                );
                toast.success(isEdit ? "Category updated" : "Category added");
                setIsOpen(false);
                setSelectedCategory(null);
                 if (!isEdit) {
                    fetchCategories();
                }
            } else {
                toast.error(res.message || "Operation failed");
            }
        } catch (error) {
            console.error("Error submitting category:", error);
            toast.error("Unexpected error occurred");
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Category details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="categoryName" className="oms-form-label">
                            Category Name
                        </label>
                        <input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter category name"
                        />
                    </div>
                    
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BusinessCategoryModal;
